var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FormSelect',{attrs:{"context":_vm.context,"current-options":_vm.schools,"search":_vm.getSchools,"special-prefix":"Iná škola"}})}
var staticRenderFns = []

export { render, staticRenderFns }